<script lang="ts">
  export let centred = true;
  export let condensed = false;
  export let display = false;
  export let end = 0;
  export let size = 1;
  export let lineHeight = size;
  export let type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' = 'p';
</script>

{#if type === 'h1'}
  <h1
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </h1>
{:else if type === 'h2'}
  <h2
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </h2>
{:else if type === 'h3'}
  <h3
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </h3>
{:else if type === 'h4'}
  <h4
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </h4>
{:else if type === 'h5'}
  <h5
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </h5>
{:else if type === 'h6'}
  <h6
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </h6>
{:else if type === 'p'}
  <p
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </p>
{:else if type === 'span'}
  <span
    class:centred
    class:condensed
    class:display
    style:--size={size}
    style:--line-height={lineHeight}
    style:--end={end}
  >
    <slot />
  </span>
{/if}

<style>
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span {
    font-family: Optima;
    font-weight: 400;
    margin: 0;
    font-size: calc(var(--size) * 1rem);
    line-height: calc(var(--line-height) * 1rem);
    margin-block-end: calc(var(--end) * 1rem);
    text-align: left;
  }

  .display {
    font-family: 'Cormorant Garamond';
    letter-spacing: 1px;
  }

  .condensed {
    letter-spacing: -1px;
  }

  .centred {
    text-align: center;
  }
</style>
